import { ChevronLeft } from 'lucide-react';
import { ReactNode } from 'react';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Stack } from '../../../design-system/stack/stack';

type PaymentFlowStepWrapperProps = {
  children: ReactNode;
  title: string;
  onGoBack: () => void;
};

export const PaymentFlowStepWrapper = ({ children, title, onGoBack }: PaymentFlowStepWrapperProps) => {
  return (
    <Stack space={3} align="stretch">
      <Inline space={3}>
        <Button variant="ghost" size="icon" className="bg-white" onClick={onGoBack} aria-label="Go back">
          <ChevronLeft size={16} />
        </Button>

        <h2 className="text-base font-medium text-black">{title}</h2>
      </Inline>

      {children}
    </Stack>
  );
};
